// This was generated during the migration to @kiwicom/eslint-config
// PLEASE REMOVE THE GLOBAL ESLINT DISABLE BELOW
// AND FIX ERRORS ACCORDINGLY.
/* eslint-disable func-names, no-proto */

;(function () {
  if (!(Object.setPrototypeOf || {}.__proto__)) {
    const nativeGetPrototypeOf = Object.getPrototypeOf

    Object.getPrototypeOf = function (object) {
      if (object.__proto__) {
        return object.__proto__
      }
      return nativeGetPrototypeOf.call(Object, object)
    }
  }
})()
